<template>
    <div class="container-fluid bg-jc m-0 p-0 animated fadeIn slow">
        <div class="container px-0" style="position: relative;">
            <div class="d-flex flex-column" style="height: 99vh; ">
                <div class="mr-auto mt-3 ml-3">
                    <logo></logo>
                </div>
                <div class="align-self-center my-auto ml--5">
                    <div class="phone font-italic font-weight-bold"><a href="tel:1-877-783-8707">1 (877) RUFUS - 07</a>
                    </div>
                    <div class="lime-bar-diag">
                        <img src="../assets/img/Asset_3.png" alt="" class="ml-4 pl-5">
                    </div>
                    <div class="text-uppercase font-italic sub-title-wrapper">
                    <span @click="redirectHandler()" class="sub-title" style="cursor: default;">
                        <h1>404 - Page Not Found...</h1>

                        <div class="mt-5">
                            <img src="../assets/img/instagram-logo-black.svg" alt="" style="height: 50px; width: auto; opacity: 0.6;">
                            rufus_legacy
                        </div>

                        <div class="mt-5">
                            <img src="../assets/img/twitter_logo_black.svg" alt="" style="height: 50px; width: auto; opacity: 0.6;">
                            @rufus_legacy
                        </div>
                    </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="lime-bar-footer"></div>
    </div>

</template>

<script>
    // @ is an alias to /src
    import logo from '@/components/RufusLogo'

    export default {
        name      : 'p404',
        components: {
            logo
        },
        created () {
            this.$store.dispatch('getUserAccount')
        },
        watch     : {
            userAccount (val) {
                if ( val === 'admin' || val === 'driver' || val === 'industry' ) {
                    // console.log('admin or driver...');
                    this.$router.push({name: 'toc'})
                } else {
                    // console.log('not admin or driver');
                    this.$router.push({name: 'login'})
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/_vars.scss';

    .lime-bar-diag {
        transform: translateY(-30px);
        z-index: 0;
        position: relative;
    }

    .phone {
        a {
            font-size: 30px;
            color: #666666;
            text-decoration: none;
            cursor: default;
        }

        z-index: 1;
        position: relative;
    }

    .sub-title-wrapper {
        margin-top: -50px;
    }

    .sub-title {
        margin-left: 180px;
    }

    .bg-jc {
        background-image: url(../assets/img/Jim_Clark.png);
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
    }
</style>
